import React from 'react';
import useMedia from 'use-media';

export const Cart = ({ className, width = 24 }) => {
  const isWide = useMedia({ minWidth: '1280px' });

  return (
    <svg width={width} viewBox="0 0 32 32" fill="none" className={className}>
      <path
        d="M4 4H6.66667L7.2 6.66667M7.2 6.66667H28L22.6667 17.3333H9.33333M7.2 6.66667L9.33333 17.3333M9.33333 17.3333L6.276 20.3907C5.436 21.2307 6.03067 22.6667 7.21867 22.6667H22.6667M22.6667 22.6667C21.9594 22.6667 21.2811 22.9476 20.781 23.4477C20.281 23.9478 20 24.6261 20 25.3333C20 26.0406 20.281 26.7189 20.781 27.219C21.2811 27.719 21.9594 28 22.6667 28C23.3739 28 24.0522 27.719 24.5523 27.219C25.0524 26.7189 25.3333 26.0406 25.3333 25.3333C25.3333 24.6261 25.0524 23.9478 24.5523 23.4477C24.0522 22.9476 23.3739 22.6667 22.6667 22.6667ZM12 25.3333C12 26.0406 11.719 26.7189 11.219 27.219C10.7189 27.719 10.0406 28 9.33333 28C8.62609 28 7.94781 27.719 7.44772 27.219C6.94762 26.7189 6.66667 26.0406 6.66667 25.3333C6.66667 24.6261 6.94762 23.9478 7.44772 23.4477C7.94781 22.9476 8.62609 22.6667 9.33333 22.6667C10.0406 22.6667 10.7189 22.9476 11.219 23.4477C11.719 23.9478 12 24.6261 12 25.3333Z"
        stroke="#2A4365"
        strokeWidth={isWide ? 3 : 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
